<template>
  <div class="app-container profile-container">
    <el-row :gutter="24">
      <el-col :span="8" :xs="24">
        <el-card class="profile-card info-card" shadow="hover">
          <template #header>
            <div class="card-header">
              <svg-icon icon-class="user" class="header-icon" />
              <span class="header-title">个人信息</span>
            </div>
          </template>
          <div class="profile-content">
            <div class="avatar-section">
              <userAvatar />
            </div>
            <div class="info-list">
              <div class="info-item" v-for="(item, index) in infoItems" :key="index">
                <div class="info-icon">
                  <svg-icon :icon-class="item.icon" />
                </div>
                <div class="info-content">
                  <div class="info-label">{{ item.label }}</div>
                  <div class="info-value">{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="16" :xs="24">
        <el-card class="profile-card form-card" shadow="hover">
          <template #header>
            <div class="card-header">
              <svg-icon icon-class="edit" class="header-icon" />
              <span class="header-title">基本资料</span>
            </div>
          </template>
          <div class="form-content">
            <el-tabs v-model="activeTab" class="custom-tabs">
              <el-tab-pane label="基本资料" name="userinfo">
                <userInfo :user="user" @update-user-info="updateUserInfo" />
              </el-tab-pane>
              <el-tab-pane label="修改密码" name="resetPwd">
                <resetPwd />
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import userAvatar from "./userAvatar";
import userInfo from "./userInfo";
import resetPwd from "./resetPwd";
import { getUserProfile } from "@/service/main/system/user";

export default {
  name: "Profile",
  components: { userAvatar, userInfo, resetPwd },
  data() {
    return {
      user: {},
      roleGroup: {},
      postGroup: {},
      activeTab: "userinfo"
    };
  },
  computed: {
    infoItems() {
      return [
        {
          icon: 'user',
          label: '用户名称',
          value: this.user.userName || '-'
        },
        {
          icon: 'phone',
          label: '手机号码',
          value: this.user.phonenumber || '-'
        },
        {
          icon: 'email',
          label: '用户邮箱',
          value: this.user.email || '-'
        },
        {
          icon: 'tree',
          label: '所属部门',
          value: this.user.dept ? `${this.user.dept.deptName} / ${this.postGroup}` : '-'
        },
        {
          icon: 'peoples',
          label: '所属角色',
          value: this.roleGroup || '-'
        },
        {
          icon: 'date',
          label: '创建日期',
          value: this.user.createTime || '-'
        }
      ];
    }
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      getUserProfile().then(response => {
        this.user = response.data;
        this.roleGroup = response.roleGroup;
        this.postGroup = response.postGroup;
      });
    },
    updateUserInfo(info) {
      // 更新用户信息
      this.user = { ...this.user, ...info };
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-container {
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: calc(100vh - 84px);
  position: relative;
  
  // 添加背景装饰
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="%23ffffff" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="%23ffffff" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="%23ffffff" opacity="0.1"/><circle cx="10" cy="60" r="0.5" fill="%23ffffff" opacity="0.1"/><circle cx="90" cy="40" r="0.5" fill="%23ffffff" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    pointer-events: none;
  }
}

.profile-card {
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  // 添加卡片光晕效果
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, #667eea, #764ba2, #667eea);
    border-radius: 14px;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: -1;
  }
  
  &:hover {
    transform: translateY(-2px);
    
    &::before {
      opacity: 0.3;
    }
  }
  
  .el-card__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px 12px 0 0;
    padding: 20px;
    border-bottom: none;
    position: relative;
    
    // 添加头部装饰
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    }
  }
  
  .el-card__body {
    padding: 30px;
    background: white;
  }
}

.card-header {
  display: flex;
  align-items: center;
  color: white;
  
  .header-icon {
    font-size: 20px;
    margin-right: 10px;
  }
  
  .header-title {
    font-size: 18px;
    font-weight: 600;
  }
}

.info-card {
  .profile-content {
    .avatar-section {
      text-align: center;
      margin-bottom: 30px;
      padding: 20px 0;
    }
    
    .info-list {
      .info-item {
        display: flex;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;
        transition: all 0.3s ease;
        
        &:last-child {
          border-bottom: none;
        }
        
        &:hover {
          background: rgba(102, 126, 234, 0.05);
          border-radius: 8px;
          padding-left: 10px;
          padding-right: 10px;
        }
        
        .info-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
          
          .svg-icon {
            color: white;
            font-size: 16px;
          }
        }
        
        .info-content {
          flex: 1;
          
          .info-label {
            font-size: 14px;
            color: #666;
            margin-bottom: 4px;
          }
          
          .info-value {
            font-size: 16px;
            color: #333;
            font-weight: 500;
          }
        }
      }
    }
  }
}

.form-card {
  .form-content {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    padding: 30px;
    margin: -30px;
    
    .custom-tabs {
      ::v-deep .el-tabs__header {
        margin-bottom: 30px;
        
        .el-tabs__nav-wrap {
          &::after {
            display: none;
          }
        }
        
        .el-tabs__item {
          font-size: 16px;
          font-weight: 500;
          color: #666;
          padding: 0 30px;
          height: 50px;
          line-height: 50px;
          border-radius: 25px;
          margin-right: 10px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #667eea;
            background: rgba(102, 126, 234, 0.1);
          }
          
          &.is-active {
            color: white;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
        }
        
        .el-tabs__active-bar {
          display: none;
        }
      }
      
      .el-tabs__content {
        padding: 20px 0;
        
        .el-tab-pane {
          background: white;
          border-radius: 12px;
          padding: 30px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid #f0f0f0;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .profile-container {
    padding: 10px;
  }
  
  .profile-card {
    margin-bottom: 20px;
    
    .el-card__body {
      padding: 20px;
    }
  }
  
  .info-card .profile-content .info-list .info-item {
    padding: 12px 0;
    
    .info-icon {
      width: 35px;
      height: 35px;
      margin-right: 12px;
      
      .svg-icon {
        font-size: 14px;
      }
    }
    
    .info-content {
      .info-label {
        font-size: 13px;
      }
      
      .info-value {
        font-size: 14px;
      }
    }
  }
}
</style>
